module.exports = __webpack_public_path__ + "assets/img/home-selected-report-light.f87ac729.png";